import { render } from "./ModalDocumentCreateName.vue?vue&type=template&id=42f9a171&scoped=true"
import script from "./ModalDocumentCreateName.vue?vue&type=script&lang=js"
export * from "./ModalDocumentCreateName.vue?vue&type=script&lang=js"

import "./ModalDocumentCreateName.vue?vue&type=style&index=0&id=42f9a171&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f9a171"]])

export default __exports__